module.exports = __webpack_public_path__ + "img/number_6.d8302277.png";